import React from "react";
import { connect } from "react-redux";
import SliderImages from '~/components/layout/SliderImages';
import {
  Container,
  Logo,
  LogoMobile,
  Header,
  HeaderMobile,
  FormContainer,
  LoginTitle,
  LoginBox,
  LeftContainer,
  RightContainer,
  FirstAccessContainer,
  Background,
  GradienteCenter,
  ImageCenterContainer,
  GradienteMobileImage,
} from "./styles";
import EmployeesPasswordForm from "~/components/pages/EmployeesPassword/Form";
import { useSelector } from "react-redux";
import LogoMap from '~/assets/images/Login/meu-app-branca.png';
import LogoWhite from '~/assets/images/Login/logo-branca.png';

function SignUp(props) {
  const step = useSelector((state) => state.employeeReducer.stepEmployeePassword);

  return (
    <Background>
      <GradienteCenter/>
      <GradienteMobileImage />
      <Container>
      <LeftContainer>
          <>
            <img src={LogoWhite} alt='Ultragas'/>
          </>
        </LeftContainer>
        <ImageCenterContainer>
          <SliderImages />
        </ImageCenterContainer>
        <RightContainer>
          <LoginBox>
            <Header className="pt-4 pb-4">
              <Logo src={LogoMap} alt='UltraGaz' />
            </Header>
            <HeaderMobile className="pt-4 pb-4">
              <LogoMobile src={LogoWhite} alt='UltraGaz'/>
            </HeaderMobile>
            <FormContainer>
              <LoginTitle className="mb-3">
                { step  !== 2 ? "Crie sua senha" : "Senha criada!" }
              </LoginTitle>
              <EmployeesPasswordForm />
            </FormContainer>
            <FirstAccessContainer className="mt-5"></FirstAccessContainer>
          </LoginBox>
        </RightContainer>
      </Container>
    </Background>
  );
}

export default connect()(SignUp);
